import * as classnames from 'classnames';
import * as React from 'react';

import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router';

import { getWalletAccount } from 'actions/wallet';
import { Button } from 'components/Button';
import { LayoutHeader } from 'components/Layout';
import { LoaderBlock } from 'components/Loader';
import { AccountProfileStatus } from 'constants/account';
import { ROUTE_ACCOUNT_KYC_REGISTER, ROUTE_ACCOUNT_KYC_WAITING } from 'constants/app';
import { ImageKycSampleKtp } from 'images/index';
import { Account } from 'models/account';
import { AppState } from 'models/app';
import { WalletAccountState } from 'models/wallet';

import './AccountKycOverview.scss';

interface Feature {
  icon: string;
  text: string;
  textValues?: {[key: string]: string | JSX.Element};
}

interface StateProps {
  account: Account;
  walletAccountState: WalletAccountState;
}

interface DispatchProps {
  getWalletAccount: typeof getWalletAccount;
}

type OwnProps = RouteComponentProps<{}>;
type AccountKycOverviewProps = StateProps & DispatchProps & OwnProps;

class AccountKycOverviewContainer extends React.Component<AccountKycOverviewProps, {}> {
  private features: Feature[];

  constructor(props: AccountKycOverviewProps) {
    super(props);

    this.features = [{
      icon: 'ic-invoice',
      text: 'account.kyc.overview.feature.invoice.text'
    }, {
      icon: 'ic-rupiah',
      text: 'account.kyc.overview.feature.max.balance.text',
      textValues: {
        amount: <b><FormattedMessage id="account.kyc.overview.feature.max.balance" /></b>
      }
    }, {
      icon: 'ic-transaction',
      text: 'account.kyc.overview.feature.max.money.in.text',
      textValues: {
        amount: <b><FormattedMessage id="account.kyc.overview.feature.max.money.in" /></b>
      }
    }, {
      icon: 'ic-money-out',
      text: 'account.kyc.overview.feature.transfer.text'
    }];

    this.goToKycRegister = this.goToKycRegister.bind(this);
  }

  componentWillMount() {
    const { walletAccountState } = this.props;
    if (walletAccountState.walletAccount.type.id === '') {
      this.props.getWalletAccount();
    }
  }

  render() {
    const { account, history, walletAccountState } = this.props;

    if (walletAccountState.walletAccount.type.id !== '' && account.profile && account.profile.status === AccountProfileStatus.PENDING) {
      return <Redirect to={ROUTE_ACCOUNT_KYC_WAITING} />;
    }

    return (
      <LoaderBlock
        className="o-container o-container--fluid o-container--fluid-vertical o-container__flex-column u-full-height"
        blocking={walletAccountState.isLoading}
      >
        <div className="o-container__flex--full o-container__flex-column o-container__flex--center">
          <LayoutHeader actionIcon="ic-close" actionHandler={history.goBack}>
            <h1 className="o-layout-header-title">
              <FormattedMessage id="account.kyc.overview.title"/>
            </h1>
          </LayoutHeader>
          <img alt="kyc sample ktp" src={ImageKycSampleKtp}/>
          <span className="account-kyc-overview__notice">
            <FormattedMessage id="account.kyc.overview.notice" />
          </span>

          <p className="account-kyc-overview__message o-subhead u-medium">
            <FormattedMessage id="account.kyc.overview.message" />
          </p>

          {this.renderFeatures}
        </div>
        <Button
          onClick={this.goToKycRegister}
          className="button--green button--full"
          type="button"
        >
          <FormattedMessage id="account.kyc.overview.upgrade.button" />
        </Button>
      </LoaderBlock>
    );
  }

  get renderFeatures() {
    return this.features.map((feature, index) => {
      const content = feature.textValues ?
        <FormattedMessage id={feature.text} values={feature.textValues} /> :
        <FormattedMessage id={feature.text} />;
      return (
        <p key={index} className="account-kyc-overview__feature">
          <i className={classnames(feature.icon, 'account-kyc-overview__feature-icon o-icon-action')} />
          <span className="account-kyc-overview__feature-text">
            {content}
          </span>
        </p>
      );
    });
  }

  private goToKycRegister() {
    const { history } = this.props;
    history.push(ROUTE_ACCOUNT_KYC_REGISTER);
  }
}

export const AccountKycOverview = connect<StateProps, DispatchProps, OwnProps>(
  (state: AppState) => ({
    account: state.accountState.account,
    walletAccountState: state.walletState.accountState
  }), { getWalletAccount }
)(AccountKycOverviewContainer);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Account/Kyc/AccountKycOverview/AccountKycOverview.tsx